module.exports = __webpack_public_path__ + "static/GJN-82c9fe8ec0816cba0ca0e0c4e3851611.png";